const TemplatesStarIcon = ({ className }: { className?: string }) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M3.75 23V17.5M3.75 6.5V1M1 3.75H6.5M1 20.25H6.5M13.1 2.1L11.1924 7.05975C10.8822 7.8663 10.7271 8.26958 10.4859 8.60879C10.2721 8.90944 10.0094 9.17211 9.70879 9.38588C9.36958 9.62708 8.9663 9.78219 8.15975 10.0924L3.2 12L8.15975 13.9076C8.9663 14.2178 9.36958 14.3729 9.7088 14.6141C10.0094 14.8279 10.2721 15.0906 10.4859 15.3912C10.7271 15.7304 10.8822 16.1337 11.1924 16.9403L13.1 21.9L15.0076 16.9402C15.3178 16.1337 15.4729 15.7304 15.7141 15.3912C15.9279 15.0906 16.1906 14.8279 16.4912 14.6141C16.8304 14.3729 17.2337 14.2178 18.0403 13.9076L23 12L18.0403 10.0924C17.2337 9.78219 16.8304 9.62708 16.4912 9.38588C16.1906 9.17211 15.9279 8.90944 15.7141 8.60879C15.4729 8.26958 15.3178 7.8663 15.0076 7.05975L13.1 2.1Z"
        stroke="url(#paint0_linear_1543_1088)"
        strokeWidth="1.51724"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id="paint0_linear_1543_1088" x1={12} y1={1} x2={12} y2={23} gradientUnits="userSpaceOnUse">
          <stop stopColor="#5FD5DE" />
          <stop offset={1} stopColor="#C0DE60" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TemplatesStarIcon;
